module.exports = __webpack_public_path__ + "static/alexwork6-32138c9ebeeb97b79af24d3c3ab00570.jpg";